module.exports = __webpack_public_path__ + "img/8ce595aa4cd047fe96a81d90256f51f6.112a14d5.png";